import { getPathDetails, cdnOrigin } from '../../common/environments';
import { activateCouponCode } from '../../common/urls';

const OVERRIDE = null;

function getPremiumLearningHubUrl() {
  const { lang } = getPathDetails();
  return `${cdnOrigin}/${lang}/premium/home`;
}

export default class SupportRedeemCode {
  constructor(appShadowRoot) {
    this.appShadowRoot = appShadowRoot;

    if (new URLSearchParams(window.location.search).get('support-tab') !== 'redeem-code') {
      // Redirect to home page
      const home = new URL(window.location.href)
      home.searchParams.set('support-tab', 'home')
      window.location.replace(home.toString())
    }

    this.hideSidebar();
    this.fillCodeFromQueryParam();
    this.listenToForm()
  }

  hideSidebar() {
    const sidebar = this.appShadowRoot.querySelector('.left_support_tabs_sec');
    if (sidebar) {
      sidebar.classList.add('is-hidden');
    }
  }

  fillCodeFromQueryParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    if (code) {
      const input = this.appShadowRoot.querySelector('#redeem-code-form input.input[type="text"]');
      if (input) {
        input.value = code;
      }
    }
  }

  // eslint-disable-next-line consistent-return
  listenToForm() {
    const form = this.appShadowRoot.querySelector('#redeem-code-form');
    const input = form.querySelector('input[type="text"]')
    const button = form.querySelector('button[type="submit"]');
    const error = this.appShadowRoot.querySelector('#input-error-message');
    const page1 = this.appShadowRoot.querySelector('#support-redeem-code');
    const page2 = this.appShadowRoot.querySelector('#support-redeem-code-success');

    page1?.classList.remove('is-hidden');
    page2?.classList.add('is-hidden');

    if (!form) return alert("Form not found");

    const setDisabled = (disabled = true) => {
      button.disabled = disabled;
      input.disabled = disabled;
    }

    const activateCode = async (code, override = null) => {
      switch (override) {
        case true: return Promise.resolve();
        case false: return Promise.reject();
        case null:
        default:
          return SupportRedeemCode.activateCode(code);
      }
    }

    const wait = (ms) => new Promise(resolve => { setTimeout(resolve, ms) });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const code = input.value;
      setDisabled(true);
      await activateCode(code, OVERRIDE)
        .then(() => wait(1000)) // FIXME: simulate network request latency
        .then(() => {
          error.classList.add('is-hidden');
          page1.classList.add('is-hidden');
          page2.classList.remove('is-hidden');
            page2.animate({
              opacity: [0, 1],
              transform: ['translateY(2em)', 'translateY(0%)'],
            }, {
              duration: 500,
              easing: 'ease-in-out'
            });

          wait(3000).then(() => {
            window.location.href = getPremiumLearningHubUrl();
          })
        })
        .catch((err) => {
          console.error(err);
          error.classList.remove('is-hidden');
        })
        .finally(() => setDisabled(false))
      return false
    });
  }

  static activateCode(code) {
    // See https://wiki.corp.adobe.com/display/CESTRATINTELandOPS/ACS+Authorization+Service+Documentation
    const token = window.adobeIMS.getAccessToken()?.token || ''
    return fetch(activateCouponCode, {
      method: 'POST',
      body: JSON.stringify({ code }),
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    })
    .then(r => {
        if (r.ok) {
          return r.json()
        }
        throw new Error('Failed to activate coupon code')
    })
  }
}
